<div class="pendencies">
  <div class="disclaimer" *ngIf="!maintenance?.company">
    <disclaimer message="{{ 'MAINTENANCES.TABS.PENDENCIES.NO_COMPANY' | translate }}"></disclaimer>
  </div>

  <button
    *ngIf="!pendenciesPage?.items?.length && !isLoading && permissions?.canCreate"
    (click)="openCreatePendencyDialog()"
    class="pendencies__no-pendencies-button"
    [disabled]="!maintenance?.company"
    [ngClass]="{ 'cursor-not-allowed': !maintenance?.company }"
  >
    <mat-icon class="pendencies__no-pendencies-button__icon">add</mat-icon>
    <span class="pendencies__no-pendencies-button__text">{{
      'MAINTENANCES.TABS.PENDENCIES.NO_PENDENCIES' | translate
    }}</span>
  </button>

  <div
    *ngIf="!pendenciesPage?.items?.length && !isLoading && !permissions?.canCreate"
    class="pendencies__no-pendencies-locked"
  >
    <mat-icon class="pendencies__no-pendencies-locked__icon">lock</mat-icon>
    <span class="pendencies__no-pendencies-locked__text">{{
      'MAINTENANCES.TABS.PENDENCIES.NO_PERMISSION' | translate
    }}</span>
  </div>

  <div class="pendencies__list" *ngIf="pendenciesPage?.items?.length && !isLoading">
    <span class="pendencies__list__title">
      {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCIES' | translate: { count: pendenciesPage?.totalCount } }}
    </span>

    <button *ngIf="permissions?.canCreate" (click)="openCreatePendencyDialog()" class="pendencies__list__button">
      {{ 'MAINTENANCES.TABS.PENDENCIES.ADD_NEW_PENDENCY' | translate }}
    </button>

    <div class="pendencies__list__items">
      <div
        #pendenciesListElement
        fusePerfectScrollbar
        class="pendencies__list__items__scroll"
        (scroll)="onScroll($event)"
      >
        <div [@listAnimation]="pendenciesPage?.items.length" class="pendencies__list__items__scroll__pendencies">
          <div
            *ngFor="let pendency of pendenciesPage?.items"
            class="pendencies__list__items__scroll__pendencies__pendency"
          >
            <img
              (error)="pendency.company.avatarUrl = null"
              class="pendencies__list__items__scroll__pendencies__pendency__image"
              [src]="pendency.company?.avatarUrl || 'assets/images/icons/mdi_office-building.svg'"
              alt="pendency image"
            />

            <div class="pendencies__list__items__scroll__pendencies__pendency__text">
              <div class="pendencies__list__items__scroll__pendencies__pendency__text__names">
                <span
                  matTooltip
                  tooltipWhenTruncated="{{ pendency.company?.name }}"
                  class="pendencies__list__items__scroll__pendencies__pendency__text__names__company"
                  >{{ pendency.company?.name }}</span
                >
                <span
                  matTooltip
                  tooltipWhenTruncated="{{ pendency.title }}"
                  class="pendencies__list__items__scroll__pendencies__pendency__text__names__pendency"
                  >{{ pendency.title }}</span
                >
              </div>
              <span
                matTooltip
                tooltipWhenTruncated="{{ pendency.pendencyType.name }}"
                class="pendencies__list__items__scroll__pendencies__pendency__text__description"
              >
                ID #{{ pendency.identifier }} | {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCY_TYPE' | translate }}:
                {{ pendency.pendencyType.name }}
              </span>
            </div>

            <div class="pendencies__list__items__scroll__pendencies__pendency__status">
              <span
                *ngIf="pendency.status === 'done'"
                class="pendencies__list__items__scroll__pendencies__pendency__status pendency-status--done"
              >
                {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCY_STATUS.DONE' | translate }}
              </span>
              <span
                *ngIf="pendency.status === 'opened'"
                class="pendencies__list__items__scroll__pendencies__pendency__status pendency-status--opened"
              >
                {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCY_STATUS.OPENED' | translate }}
              </span>
              <span
                *ngIf="pendency.archived"
                class="pendencies__list__items__scroll__pendencies__pendency__status pendency-status--archived"
              >
                {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCY_STATUS.ARCHIVED' | translate }}
              </span>

              <ng-container *ngIf="pendency.status !== 'done'">
                <span
                  *ngIf="pendency.treatmentStatus === 'enterprise'"
                  class="pendencies__list__items__scroll__pendencies__pendency__status pendency-status--enterprise"
                >
                  {{ 'MAINTENANCES.TABS.PENDENCIES.TREATMENT_STATUS.ENTERPRISE' | translate }}
                </span>
                <span
                  *ngIf="pendency.treatmentStatus === 'company'"
                  class="pendencies__list__items__scroll__pendencies__pendency__status pendency-status--company"
                >
                  {{ 'MAINTENANCES.TABS.PENDENCIES.TREATMENT_STATUS.COMPANY' | translate }}
                </span>
              </ng-container>
            </div>

            <div
              (click)="
                pendency.status !== 'done' && permissions.canEdit
                  ? updateAssignee(pendency.id, pendency.assignee)
                  : null
              "
            >
              <div
                *ngIf="!pendency.assignee"
                [ngClass]="{ locked: pendency.status === 'done' || !permissions.canEdit }"
                [matTooltip]="getTooltipText(pendency)"
                class="pendencies__list__items__scroll__pendencies__pendency__assignee"
              >
                <mat-icon
                  class="pendencies__list__items__scroll__pendencies__pendency__assignee__icon material-icons-outlined"
                  >{{
                    pendency.status !== 'done' && permissions.canEdit ? 'account_circle_outlined' : 'lock'
                  }}</mat-icon
                >
              </div>

              <img
                *ngIf="pendency.assignee"
                [matTooltip]="getTooltipText(pendency)"
                [ngClass]="{ locked: pendency.status === 'done' || !permissions.canEdit }"
                (error)="pendency.assignee.avatarUrl = null"
                [src]="
                  pendency.assignee?.avatarUrl || 'https://ui-avatars.com/api/?name=' + (pendency.assignee?.name || '')
                "
                alt="assignee image"
                class="pendencies__list__items__scroll__pendencies__pendency__assignee__image"
              />
            </div>

            <mat-icon
              (click)="redirectToPendencyDetails(pendency.id)"
              class="pendencies__list__items__scroll__pendencies__pendency__redirect"
              >open_in_new</mat-icon
            >
          </div>
        </div>
      </div>
      <button
        [disabled]="isLoadingPendencies || !enableLoadMoreButton"
        [class.enabled]="enableLoadMoreButton && !isLoadingPendencies"
        [class.is-loading]="isLoadingPendencies"
        (click)="loadMorePendencies()"
        class="pendencies__list__items__load-more"
        type="button"
      >
        {{ 'MAINTENANCES.TABS.PENDENCIES.LOAD_MORE' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="pendencies__loading">
    <mat-spinner color="primary" diameter="64"></mat-spinner>
    {{ 'MAINTENANCES.TABS.PENDENCIES.LOADING' | translate }}
  </div>
</div>
